import { HStack, Tag, TagLabel, TagLeftIcon, Text, VStack } from "@chakra-ui/react";
import type { JobListItem } from "@models/Job";
import { getHumanReadableCompetences, getJobStatusTagDetails } from "@utils/utils";
import Chevron from "@components/icons/Chevron";
import Lock from "@components/icons/Lock";
import moment from "moment";
import { useOrganisation } from "@api/hooks";

interface Props {
	job: JobListItem;
	onClick?: () => any;
}

export const JobRow: React.FC<Props> = ({ job, onClick }) => {
	const { organisation } = useOrganisation();

	if (!organisation) {
		return null;
	}

	const { text, backgroundColor, color, iconType } = getJobStatusTagDetails(job);

	return (
		<HStack width={"100%"} onClick={onClick} justifyContent={"space-between"} cursor={"pointer"}>
			<VStack align={"flex-start"}>
				<Text fontSize={"16px"} fontWeight={400} color={"#999999"} m={0}>
					Uppdrag {job.orderNumber}
				</Text>
				<Text fontSize={"16px"} fontWeight={500} m={0}>
					{job.customer.name}
				</Text>
				<Text fontSize={"16px"} fontWeight={400} m={0}>
					{`${moment(job.startDate)
						.locale("sv")
						.format("ddd D/M")
						.replace(/^\w/, (c) => c.toUpperCase())} - ${
						job.competence && getHumanReadableCompetences(job.competence, organisation.competences)
					}`}
				</Text>
			</VStack>
			<HStack>
				<Tag size={"sm"} variant="subtle" bg={backgroundColor} borderRadius={"2px"}>
					{iconType && <TagLeftIcon boxSize="12px" as={getIcon(iconType)} />}
					<TagLabel color={color}>{text}</TagLabel>
				</Tag>
				<Chevron />
			</HStack>
		</HStack>
	);
};

const getIcon = (icon: string): React.FC => {
	if (icon === "LOCK") {
		const LockIcon: React.FC = () => (
			<div style={{ marginRight: "5px" }}>
				<Lock size={12} />
			</div>
		);
		LockIcon.displayName = "LockIcon"; // Add displayName property
		return LockIcon;
	}
	const EmptyIcon: React.FC = () => <span></span>;
	EmptyIcon.displayName = "EmptyIcon"; // Add displayName property
	return EmptyIcon;
};
